var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvisoryCommittee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.582 18.8904V17.2678C19.4246 15.3908 17.2449 15.4151 17.2449 15.4151H13.8058C11.3355 15.4635 11.4203 17.2678 11.4203 17.2678V18.8904H19.582Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1624 6.32102H13.562V8.13742H17.3886V6.30891H17.8003V8.14953H19.0718V6.0425C18.9265 4.38352 17.0132 4.40773 17.0132 4.40773H15.9839L15.5722 5.08586L15.1604 4.40773H13.9858C11.8183 4.44406 11.8909 6.0425 11.8909 6.0425V8.13742H13.1624V6.32102Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4281 8.42822H10.5469V9.88135H20.4281V8.42822Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5723 3.92334C16.4082 3.92334 17.0859 3.24565 17.0859 2.40967C17.0859 1.57369 16.4082 0.895996 15.5723 0.895996C14.7363 0.895996 14.0586 1.57369 14.0586 2.40967C14.0586 3.24565 14.7363 3.92334 15.5723 3.92334Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8111 17.05V18.8906H27.9728V17.05C27.8154 15.1731 25.6357 15.1973 25.6357 15.1973H22.1966C19.7142 15.2457 19.8111 17.05 19.8111 17.05Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9891 14.6524C24.9336 14.6524 25.7086 13.8774 25.7086 12.9329C25.7086 11.9884 24.9457 11.2134 23.9891 11.2134C23.0445 11.2134 22.2695 11.9763 22.2695 12.9329C22.2695 13.8774 23.0445 14.6524 23.9891 14.6524Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92578 19.6411V22.4868H3.48789V30.1036H27.5008V22.4868C27.5008 22.4868 28.2879 22.4868 29.075 22.4868V19.6411H1.92578Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4195 14.6521L19.2551 10.2563H11.7109L12.5586 14.6763C12.8977 14.531 13.273 14.4341 13.709 14.3978C13.4668 14.0345 13.3215 13.5985 13.3215 13.1263C13.3215 11.8548 14.3508 10.8255 15.6223 10.8255C16.8938 10.8255 17.9352 11.8669 17.9352 13.1263C17.9352 13.5985 17.7898 14.0345 17.5477 14.4099C17.8141 14.4462 18.1168 14.5188 18.4195 14.6521Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2007 18.8904V17.2678C11.0433 15.3908 8.86363 15.4151 8.86363 15.4151H5.42457C2.96637 15.4635 3.05113 17.2678 3.05113 17.2678V18.8904H11.2007Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6102 14.8702C16.5598 14.8702 17.3297 14.1004 17.3297 13.1507C17.3297 12.201 16.5598 11.4312 15.6102 11.4312C14.6605 11.4312 13.8906 12.201 13.8906 13.1507C13.8906 14.1004 14.6605 14.8702 15.6102 14.8702Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2293 14.8702C8.17897 14.8702 8.94883 14.1004 8.94883 13.1507C8.94883 12.201 8.17897 11.4312 7.2293 11.4312C6.27963 11.4312 5.50977 12.201 5.50977 13.1507C5.50977 14.1004 6.27963 14.8702 7.2293 14.8702Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvisoryCommittee);
export default __webpack_public_path__ + "static/media/Advisory Committee.4e47fbbe7f0ee845a8194afd70e4733a.svg";
export { ForwardRef as ReactComponent };